import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import UiMeet3dEventNotificationRepository from "~/repository/UiMeet3d/UiMeet3dEventNotificationRepository";
import UiMeet3dEventNotification from "~/models/UiMeet3d/UiMeet3dEventNotification";

class UiMeet3dEventNotificationStore extends NestStore {
  /**
   * @property {Array}
   */
  @observable uiMeet3dEventNotifications = [];

  /**
   * @property {UiMeet3dEventNotification}
   */
  @observable uiMeet3dEventNotification = new UiMeet3dEventNotification();

  /**
   * @property {number|null}
   */
  uiMeet3dEventNotificationId = null;

  uiMeet3dEventNotificationRepository = null;

  constructor() {
    super();

    this.uiMeet3dEventNotificationRepository = new UiMeet3dEventNotificationRepository();

    this.setDefaultSearchParams();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getOne()]).finally(() => {
      this.isLoading = false;
    });
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
    };

    // if (this.searchParams.providerId !== "") {
    //  params.providerId = this.searchParams.providerId;
    // }

    return this.uiMeet3dEventNotificationRepository.fetch(params).then(response => {
      this.processEntities(response.data.uiMeet3dEventNotifications);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(uiMeet3dEventNotifications = []) {
    this.uiMeet3dEventNotifications = [];

    uiMeet3dEventNotifications.forEach(uiMeet3dEventNotificationArray => {
      const uiMeet3dEventNotification = new UiMeet3dEventNotification(uiMeet3dEventNotificationArray);

      this.uiMeet3dEventNotifications.push(uiMeet3dEventNotification);
    });
  }

  /**
   * Change the pagination page and fetch the Ui Meet3d Event Notifications.
   */
  @action
  changePage(page) {
    this.pagination.currentPage = page;

    return this.loadIndex();
  }

  /**
   * Change the pagination page and fetch the Ui Meet3d Event Notifications.
   */
  @action
  search() {
    this.pagination.currentPage = 1;

    return this.loadIndex();
  }

  @action
  getOne() {
    return this.uiMeet3dEventNotificationRepository.fetchOne(this.uiMeet3dEventNotificationId).then(response => {
      this.uiMeet3dEventNotification = new UiMeet3dEventNotification(response.data.uiMeet3dEventNotification);
    });
  }

  @action
  create(data) {
    this.isSaving = true;

    return this.uiMeet3dEventNotificationRepository
      .create(data)
      .then(response => {
        this.uiMeet3dEventNotification = new UiMeet3dEventNotification(response.data.uiMeet3dEventNotification);
        this.isSaving = false;
      })
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      });
  }

  @action
  update(data) {
    this.isSaving = true;

    return this.uiMeet3dEventNotificationRepository
      .update(this.uiMeet3dEventNotificationId, data)
      .then(response => {
        this.uiMeet3dEventNotification = new UiMeet3dEventNotification(response.data.uiMeet3dEventNotification);
        this.isSaving = false;
      })
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      });
  }

  /**
   * Set default search params.
   */
  @action
  setDefaultSearchParams() {
    // this.searchParams.providerId = "";
  }
}

export default UiMeet3dEventNotificationStore;
